export interface GuideStep {
  id: string
  target: string
  title: string
  content: string
  optional?: boolean
}

export interface GuideDefinition {
  id: string
  path: string
  title: string
  description: string
  steps: GuideStep[]
}

export interface GuideAccess {
  isSuperAdmin: boolean
  permissions: string[]
  roles: Array<{ id: string; code: string; name: string }>
}

export type HasGuidePermission = (permission: string) => boolean

export function guideStep(
  id: string,
  target: string,
  title: string,
  content: string,
  optional = false,
): GuideStep {
  return { id, target, title, content, optional }
}
